<template>
  <div class="gate-preview">
    <div class="gate-preview-sticky">
      <div class="gate-preview-header">
        <h2 class="gate-preview-header-title">
          Preview
        </h2>
        <div class="gate-preview-header-controls">
          <img
              @click="changeView('mobile')"
              :class="['mobile-view', view ==='mobile' && 'active' ]"
              src="@/assets/gate-preview/mobile-view-icon.svg"
              alt="Mobile view"/>
          <img
              @click="changeView('laptop')"
              :class="['laptop-view', view ==='laptop' && 'active']"
              src="@/assets/gate-preview/laptop-view-icon.svg"
              alt="Laptop view" />
        </div>
      </div>
      <div :class="['gate-preview-main', view === 'mobile' && 'mobile']">
        <img :class="['iphone-view', view === 'mobile' && 'visible' ]" src="@/assets/gate-preview/iphone-view.svg" alt="Iphone view"/>
        <post-cover :view="view" :page="page" :old="old" :reward-type="rewardType" />
<!--        <campaign-post-cover :view="view" :page="page" :old="old" :reward-type="rewardType" />-->
      </div>
    </div>
  </div>
</template>
<script>
import Vue from 'vue'
import PostCover from "@/components/PostCover/PostCover.vue";
import CampaignPostCover from "@/components/CampaignPostCover/CampaignPostCover.vue";
import Preview from "@/components/Preview/Preview.vue";
export default Vue.extend({
  data() {
    return {
      view: 'laptop'
    }
  },
  components: {
    PostCover,
    CampaignPostCover,
    Preview
  },
  props: ['page', 'old', 'rewardType'],
  methods: {
    changeView(clickedView) {
      if (this.view !== clickedView) this.view = clickedView
    }
  },
})
</script>
<style lang="scss" scoped>;
.gate-preview {
  width: 100%;
  position: absolute;
  top: 0;
  left: calc(100% + 2px);
  height: 100%;
  &-sticky {
    position: sticky;
    top: 0;
  }
  @media (max-width: 1365px) {
    position: static;
    height: auto;
    &-sticky {
      position: unset;
    }
  }
  &-header {
    background-color: #F3F7FF;
    height: 74px;
    padding: 16px;
    display: flex;
    flex-direction: row;
    align-items: center;
    &-title {
      font-family: "Montserrat", sans-serif;
      font-size: 16px;
      font-weight: 600;
      line-height: 24px;
      width: 100%;
    }
    &-controls {
      display: flex;
      gap: 16px;
      border-left: 1px solid #CED4DA;
      > img {
        cursor: pointer;
        &.active {
          filter: invert(40%) sepia(97%) saturate(505%) hue-rotate(184deg) brightness(104%) contrast(98%);
        }
      }
    }
  }
  &-main {
    position: relative;
    margin: 32px 0;
    .iphone-view {
      display: none;
      width: 390px;
      height: 844px;
      position: absolute;
      top: 0;
      left: 50%;
      transform: translate(-50%, 0);
      z-index: -1;
      &.visible {
        display: block;
      }
    }
    .box-post {
      background: none;
    }
    &::v-deep .preview-450 {
      width: 450px!important;
      height: 450px!important;
    }
    &::v-deep .preview-350 {
      width: 350px!important;
      height: 350px!important;
    }
    &::v-deep .preview-200 {
      width: 200px!important;
      height: 200px!important;
    }
    &::v-deep .preview {
      &.active {
        z-index: 2;
      }
      &:not(.active) {
        z-index: 1;
      }
    }
    &.mobile {
      height: 844px;
      &::v-deep .box-post {
        flex-direction: column;

        width: 350px;
        min-height: 350px;
        &__img {
          margin-top: 68px;
          width: 350px;
          height: 350px;
          min-height: 350px;
        }
        &__text {
          max-width: 350px;
          max-height: 358px;
          height: 358px;
        }
      }
    }
  }
}
.mobile-view {
  padding: 6px 12px;
  margin-left: 16px;
}
@media (max-width: 1741px) {
  .gate-preview {
    &-header {}
    &-main:not(.mobile) {
      &::v-deep .box-post {
        justify-content: center;
        &__img {
          width: 350px;
          height: 350px;
          @media (max-width: 1561px) {
            width: 200px;
            height: 200px;
          }
          @media (max-width: 1401px) {
            width: 350px;
            height: 350px;
          }
          @media (max-width: 727px) {
            width: 200px;
            height: 200px;
          }
        }
        &__text {
          width: 280px;
          max-height: 350px;
          padding: 18px;
          @media (max-width: 1561px) {
            max-height: 200px;
          }
          @media (max-width: 1401px) {
            max-height: 350px;
          }
          @media (max-width: 727px) {
            max-height: 200px;
            padding: 8px;
          }
          @media (max-width: 520px) {
            width: 180px
          }
        }
      }
    }
    &-main.mobile {
      @media (max-width: 421px) {
        height: 561px;
        .iphone-view {
          width: 260px;
          height: 561px;
        }
        &::v-deep .box-post {
          width: unset;
          &__img {
            width: 200px;
            height: 200px;
            margin: 32px auto 0;
            min-height: unset;
          }
          &__text {
            width: 200px;
            margin: 0 auto;
            max-height: 310px;
          }
        }
      }
    }
  }
}

</style>
